exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.layout-img-dialog img[data-v-1124e7b2] {\n  display: block;\n  width: 100%;\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/layout/pages/home/banner/img-dialog.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;CACjB","file":"img-dialog.vue","sourcesContent":["\n.layout-img-dialog img[data-v-1124e7b2] {\n  display: block;\n  width: 100%;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1124e7b2","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/pages/home/banner/img-dialog.vue
// module id = O6tA
// module chunks = 6